module.exports = __webpack_public_path__ + "img/102.025f4edf.png";